(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/utils/normalize-draws.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/utils/normalize-draws.js');
"use strict";


const {
  isTopptipset,
  isPowerplay,
  isTopptipsetStryk,
  isTopptipsetExtra
} = svs.utils.products.helpers;
const extractDraws = response => {
  if (Array.isArray(response.draws)) {
    return response.draws;
  }
  if (Array.isArray(response.result)) {
    return response.result.map(item => item.payload.draw);
  }
  return [];
};
const stampCopyValue = draw => {
  const isCurrentProductTopptipset = isTopptipset(draw.productFamily);
  const isCurrentProductPowerplay = isPowerplay(draw.productName);
  if (!isCurrentProductTopptipset && !isCurrentProductPowerplay) {
    return;
  }
  if (isCurrentProductTopptipset) {
    let copy = 'Topptipset';
    if (isTopptipsetStryk(draw.productName)) {
      copy += ',Stryk';
    }
    if (isTopptipsetExtra(draw.productName)) {
      copy += ',Europa';
    }
    copy += ",Omg=".concat(draw.drawNumber, ",Insats=1");
    draw.copyValue = copy;
    return;
  }
  if (isCurrentProductPowerplay) {
    draw.copyValue = "Powerplay,Omg=".concat(draw.drawNumber, ",Insats=1");
  }
};
const collectAvailableSports = draws => {
  const sports = [];
  draws.forEach(draw => {
    if (Array.isArray(draw.drawEvents)) {
      draw.drawEvents.forEach(event => {
        if (event.match && event.match.sport) {
          sports.push(event.match.sport);
        }
      });
      return;
    }
    if (draw.sport) {
      sports.push(draw.sport);
    }
  });
  const seen = new Set();
  const unique = [];
  sports.forEach(sport => {
    if (!sport || sport.type == null || seen.has(sport.type)) {
      return;
    }
    seen.add(sport.type);
    unique.push(sport);
  });
  unique.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
  return unique;
};
const normalizeDraws = response => {
  const draws = extractDraws(response);
  draws.forEach(stampCopyValue);
  return {
    draws,
    availableSports: collectAvailableSports(draws),
    totalCount: response.totalCount
  };
};
setGlobal('svs.tt.utils.normalizeDraws', normalizeDraws);

 })(window);